module.exports = __webpack_public_path__ + "static/media/DC-Bird_fly.d8e3b2f9.png";